import React, {FC} from 'react'
import {StatusCounts, padCount} from './statusCounts'

// Services have no supplier-payment records anywhere in the database -- the only payments
// table is hotel-only -- so unlike hotels they show a single counter.
export const ServiceStatusCounters: FC<{counts?: StatusCounts}> = ({counts}) => {
  if (!counts) return null
  const pending = counts.confirmation_pending ?? 0
  return (
    <span className='d-inline-flex flex-wrap gap-4 ms-4 fw-bold'>
      <span className={pending > 0 ? 'text-danger' : 'text-muted'}>
        Confirmation Pending - {padCount(pending)}
      </span>
    </span>
  )
}
